import React from 'react'
import Layout from '../components/layout'

const AboutPage = () => (
    <Layout>
      <div>
        <div className="page">
          <h1 className="page-title">Acerca de Friday Songbird</h1>
          <span className="post-date">05 Mayo 2018</span>
          <p>
            La música siempre ha sido especial para mí. Desde que empecé a escuchar música por mi cuenta, allá por los últimos años de la década de los 90, cuando ya estaba terminando la secundaria, siempre he sentido que la música me ha acompañado.
          </p>
          <p>
            Y desde hace tiempo estuve queriendo hacer algo relacionado con la música y con lo mucho que me gusta, alguna forma de compartir con el mundo todo eso que la música me hace sentir, todas las historias que tengo alrededor de la música. Algo como lo que en su momento fue, para mi, el genial proyecto <a href="https://www.thisismyjam.com/">This Is My Jam</a>.
          </p>
          <p>
            Así que un día tomé esas ganas, hice un par de garabatos en mi cuaderno, y así nació la idea de Friday Songbird: un pequeño blog, hecho de forma artesanal :D, en el cual cada viernes compartiré una canción que, de un modo u otro, se ha convertido en mi favorita (o alguna vez lo fue).
          </p>
          <p>
            ¿Qué vendrá más adelante? No lo sé, quiero dejarme sorprender :). Pero lo más importante, lo que siempre será cierto, es lo siguiente:
          </p>
          <p style={{textAlign: 'center'}}>
            Es mi homenaje a la música.
          </p>
          <p>
            (Por lo pronto, una de las primeras cosas que quiero hacer es colaborar con amigos, porque este tema es mejor cuando es en grupo :) ).
          </p>
          <p>
            Así que espero que les guste, y que me acompañen tanto como dure esta gracia, que espero que sea mucho. Bienvenidos, y disfruten la música :).
          </p>
        </div>
      </div>
    </Layout>
)

export default AboutPage
